import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export default function Seeus(props) {
  const ref = useRef();

  useFrame(({ mouse, viewport }) => {
    const x = (mouse.x * viewport.width) / 2.5;
    const y = (mouse.y * viewport.height) / 2.5;
    ref.current.lookAt(x, -0.5, 1);
  });

  const { nodes, materials } = useGLTF("/seeus.glb");
  return (
    <group {...props} dispose={null} ref={ref}>
      <skinnedMesh
        name="Body"
        geometry={nodes.Body.geometry}
        material={materials.main}
        skeleton={nodes.Body.skeleton}
        morphTargetDictionary={nodes.Body.morphTargetDictionary}
        morphTargetInfluences={nodes.Body.morphTargetInfluences}
      />
      <primitive object={nodes.Hips} />
    </group>
  );
}

useGLTF.preload("/seeus.glb");
